import { getAuthorizationDApps } from '@particle-network/auth-core';
import { useRequest } from 'ahooks';
import { Skeleton } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../../components/header';
import SVGIcon from '../../../components/icon/svg-icon';
import PowerFooter from '../../../components/power-footer';
import { useCustomNavigate, useModalOptions } from '../../../context';
import { useCustomize } from '../../../context/hooks';
import styles from './index.less';

const DeviceList = () => {
    const { t } = useTranslation();
    const navigate = useCustomNavigate();
    const { modalOptions } = useModalOptions();
    const { language } = useCustomize();
    const {
        loading,
        data: deviceList = [],
        run: getAuthorizationsRequest,
    } = useRequest(
        () => {
            return getAuthorizationDApps().then((list) => {
                return list.map((item) => {
                    if (item.updated_at) {
                        // eslint-disable-next-line camelcase
                        item.updated_at = dayjs(new Date(item.updated_at)).format('YYYY/MM/DD HH:mm');
                    }
                    if (modalOptions.projectId === item.project_app_uuid) {
                        item.isCurrent = true;
                    }
                    if (item.login_channel) {
                        // eslint-disable-next-line camelcase
                        item.login_channel = item.login_channel.replace(/( |^)[a-z]/g, (L) => L.toUpperCase());
                    }
                    if (item?.location?.country_code) {
                        try {
                            // eslint-disable-next-line camelcase
                            item.location.country_name = new Intl.DisplayNames([language || 'en'], {
                                type: 'region',
                            }).of(item?.location?.country_code);
                        } catch (error) {
                            console.log('Intl.DisplayNames', error);
                        }
                    }
                    return item;
                });
            });
        },
        {
            cacheKey: 'getAuthorizations',
            manual: true,
        }
    );

    useEffect(() => {
        getAuthorizationsRequest();
    }, []);

    return (
        <div className="device-list-container">
            <style>{styles as unknown as string}</style>
            <Header displayBackBtn={true}>{t('new.authorization')}</Header>
            <div className="scroll-wrapper">
                <div className="devices-description">{t('new.authorization_tips')}</div>
                {loading ? (
                    <div className="device-list">
                        <Skeleton />
                    </div>
                ) : (
                    <div className="device-list">
                        {deviceList?.map((item, index) => {
                            return (
                                <div
                                    className="item"
                                    key={index}
                                    onClick={() => {
                                        navigate('/manageDevices/deviceDetails', {
                                            state: {
                                                loginDeviceInfo: item,
                                            },
                                        });
                                    }}
                                >
                                    <div className="left">
                                        <div className="wrap">
                                            <div className="s-row device">{item.project_app_name}</div>
                                            <div className="s-row created_at">{item.updated_at}</div>
                                        </div>
                                    </div>
                                    <div className="right">
                                        {item.isCurrent && <div className="current-icon">{t('new.current')}</div>}
                                        <SVGIcon className="arrow-right-icon" name="arrow_right_icon" />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
            <PowerFooter className="footer-box-v2" />
        </div>
    );
};

export default DeviceList;
